// extracted by mini-css-extract-plugin
export default {"container":"PortalPlace__container--3WH","isHideAdminPanel":"PortalPlace__isHideAdminPanel--i7v"};